<template>
  <!--考试-->
  <div>
    <div class="meaage-text" v-html="scoreTestMessage">
    </div>
    <h1 class="KaoShi-name">考试名称：{{ examination.testName }}</h1>
    <p class="KaoShi-time">考试时间：{{ examination.minute }}分钟</p>
    <!-- <a
      @click="kaishikaoshi()"
      style="margin-bottom: 100px; cursor: pointer"
      class="ex_btn"
      >开始考试</a
    > -->
    <div class="KaoShi-Button-box">
      <a class="KaoShi-Button"
         @click="kaishikaoshiTwo()"
      >开始考试</a
      >
    </div>
    <div style="display: none">
      <button
        type="button"
        class="uploadFile"
        id="judgePhoto"
      ></button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      examination: {}
    };
  },
  created() {
    if (this.$route.query.id) {
      this.examination.id = this.$route.query.id;
    }
    this.getScoreText();
    this.getExaminationDetail();
  },
  methods: {
    getExaminationDetail() {
      let _this = this;
      let parmas = {
        examinationId: _this.examination.id
      };
      _this.$api.examination
        .getExaminationDetail(parmas)
        .then(res => {
          if (res.code == this.$commons.RespCode.success) {
            _this.examination = res.data;
          }
        })
        .catch(() => {
        });
    },
    // 之前页面
    // kaishikaoshi() {
    //   //checkExamination
    //   let _this = this;
    //   let parmas = {
    //     examinationId: _this.examination.id,
    //   };
    //   _this.$api.examination
    //     .checkExamination(parmas)
    //     .then((res) => {
    //       if (res.code == this.$commons.RespCode.success) {
    //         // _this.examination = res.data;
    //         this.$router.push({
    //           name: "examTest",
    //           query: { examId: this.examination.id },
    //         });
    //       } else {
    //         _this.$layer.alert(
    //           res.msg,
    //           { icon: 1, closeBtn: 0 },
    //           function (index) {
    //             _this.$layer.close(index);
    //           }
    //         );
    //       }
    //     })
    //     .catch(() => {});
    // },
    // 新考试页面
    kaishikaoshi() {
      //checkExamination
      let _this = this;

      let parmas = {
        examinationId: _this.examination.id
      };
      _this.$api.examination
        .checkExamination(parmas)
        .then(res => {
          if (res.code == this.$commons.RespCode.success) {
            // _this.examination = res.data;
            this.$router.push({
              name: "text",
              query: {examId: this.examination.id}
            });
            _this.$api.text.getStartExamination().then(res => {
            });
          } else {
            _this.$layer.alert(res.msg, {icon: 1, closeBtn: 0}, function (
              index
            ) {
              _this.$layer.close(index);
            });
          }
        })
        .catch(() => {
        });
    },

    // 开始考试第二界面
    kaishikaoshiTwo() {
      let _this = this;
      let parmas = {
        examinationId: _this.examination.id
      };
      _this.$api.examination
        .checkExamination(parmas)
        .then(res => {
          if (res.code == this.$commons.RespCode.success) {
            // _this.examination = res.data;

            _this.$layer.alert("考试过程中禁止切屏或退出全屏等违规操作,违规操作次数超过两次或者离开考试页面累计时间超过20秒系统将自动交卷!!", {icon: 7, closeBtn: 0}, function (
                  index1
                ) {
                  _this.$router.push({
                    name: "text1",
                    query: {examId: _this.examination.id}
                  });
                  _this.$layer.close(index1);

                });

            // _this.$api.text.getStartExamination({examinationId: _this.examination.id, type: 2}).then(res => {
            //   if (res.code != 200) {
            //     this.$message({
            //       message: res.msg,
            //       type: "warning"
            //     });
            //   } else {
            //     //本场考试禁止离开答题页面离开页面10次后将强制交卷请勿切屏及刷新页面!
               
            //   }
            // });
          } else {
            _this.$layer.alert(res.msg, {icon: 1, closeBtn: 0}, function (
              index
            ) {
              _this.$layer.close(index);
            });
          }
        })
        .catch(() => {
        });
    },
    getScoreText() {
      let _this = this;
      let parmas = {
        examinationId: _this.examination.id
      };
      _this.$api.examination.getScoreMessage(parmas).then(res => {
        this.scoreTestMessage = res.data.scoreText;
      });
    }
  }
};
</script>
<style scoped>
a {
  text-decoration: none;
}

.meaage-text {
  padding: 10px;
  text-align: center;
  width: 100%;
  color: red;
  padding-top: 100px;
}

.KaoShi-name {
  width: 100%;
  float: left;
  text-align: center;
  color: #2b73e1;
  font-size: 30px;
  margin: 140px 0 90px 0;
}

.KaoShi-time {
  width: 100%;
  float: left;
  line-height: 30px;
  /*margin: 0 0 0 30px;*/
  /*color: #fff;*/
  font-size: 24px;
  text-align: center;
}

.KaoShi-Button-box {
  width: 100%;
  height: 100%; /* 确保父容器有高度 */
  display: grid; /* 启用 Grid 布局 */
  place-items: center; /* 水平和垂直居中 */
  cursor: pointer;
}

.KaoShi-Button {
  justify-items: center;
  display: block;
  width: 408px;
  height: 45px;
  text-align: center;
  line-height: 45px;
  background: #2b73e1;
  color: #fff;
  font-size: 18px;
  float: left;
  border-radius: 10px;
  margin-top: 80px;

}

</style>



// WEBPACK FOOTER //
// src/view/exam/examCover.vue